import { render, staticRenderFns } from "./oAuth.vue?vue&type=template&id=4d0eca65&scoped=true&"
import script from "./oAuth.vue?vue&type=script&lang=js&"
export * from "./oAuth.vue?vue&type=script&lang=js&"
import style0 from "./oAuth.vue?vue&type=style&index=0&id=4d0eca65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0eca65",
  null
  
)

export default component.exports